import { ReactNode } from "react";

import { useResponsiveness } from "@/providers/context";

export const Grid = ({
  children,
  overrideColsPerRow,
}: {
  children: ReactNode;
  overrideColsPerRow?: number;
}) => {
  const { colsPerRow } = useResponsiveness();

  return (
    <div
      className="grid gap-x-[16px] gap-y-[40px]"
      style={{
        gridTemplateColumns: `repeat(${overrideColsPerRow ?? colsPerRow}, minmax(0, 1fr))`,
      }}
    >
      {children}
    </div>
  );
};
